<template>
    <div v-if="appParams && appParams.staticTranslations">
        <div
            v-show="
                isLoggedIn && !profile.is_first_login && !isWelcomeMessageHidden
            "
            class="itb-overlay"
        ></div>
        <div
            id="itb-welcome-message"
            class=""
            v-if="
                isLoggedIn && !profile.is_first_login && !isWelcomeMessageHidden
            "
        >
            <div class="itb-welcome-message-bubble">
                <img
                    src="/images/welcome-message/bonus-buble.png"
                    alt="welcome message"
                />
                <img
                    @click="close"
                    class="itb-close-message-button"
                    src="/images/welcome-message/close-buble.png"
                    alt="close welcome message"
                />
            </div>
            <div class="itb-welcome-message-text">
                <h4 class="mb-4">
                    <span class="itb-font-bold"
                        >{{
                            appParams.staticTranslations[
                                "general.eshop_orders_get_discount_text_1"
                            ] + " "
                        }}
                    </span>
                    <br />
                    <span
                        class="itb-font-black itb-welcome-message-highlight"
                        >{{
                            appParams.staticTranslations[
                                "general.eshop_orders_get_discount_text_2"
                            ]
                        }}</span
                    >
                </h4>
                <h4>
                    <span class="itb-font-bold">{{
                        appParams.staticTranslations[
                            "general.look_bestsellers_new_sale_1"
                        ] + " "
                    }}</span
                    ><span
                        class="itb-font-black itb-welcome-message-highlight"
                        >{{
                            appParams.staticTranslations[
                                "general.look_bestsellers_new_sale_2"
                            ]
                        }}</span
                    >
                </h4>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "WelcomeMessage",
    data() {
        return {
            isVisible: true,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: "getClientLogged",
            profile: "getClientProfile",
            isWelcomeMessageHidden: "getWelcomeMessageHidden",
            appParams: "getAppParams",
        }),
    },

    watch: {
        "profile.id": {
            deep: true,
            handler() {
                if (!!this.profile.id) {
                    this.registerFirstLogin();
                }
            },
        },
    },

    methods: {
        ...mapActions(["hideWelcomeMessage"]),

        async registerFirstLogin() {
            if (!this.profile.is_first_login) {
                await axios
                    .post("/api/auth/register-first-client-login", {
                        id: this.profile.id,
                    })
                    .then((response) => {})
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },

        close() {
            this.hideWelcomeMessage();
        },
    },
};
</script>
